<script setup>
import { inject } from 'vue';

const field = inject('field', null);
</script>
<template>
    <small v-if="field.helpText" class="text-sm text-muted block">
        {{ field.helpText }}
    </small>
</template>
